let initialServerTimeMs = 0;
let localTimeOrigin = 0;
let isSynced = false;

export function setServerTime(serverTimeMs: number) {
  initialServerTimeMs = serverTimeMs;
  localTimeOrigin = performance.now();
  isSynced = true;
  console.log(`⏱️ [TimeSync] Synchronized with server time: ${new Date(serverTimeMs).toISOString()}`);
}

export function getSyncedDate(): Date {
  if (!isSynced) {
    return new Date();
  }
  const elapsed = performance.now() - localTimeOrigin;
  return new Date(initialServerTimeMs + elapsed);
}

export function getSyncedTimeMs(): number {
  if (!isSynced) {
    return Date.now();
  }
  const elapsed = performance.now() - localTimeOrigin;
  return initialServerTimeMs + elapsed;
}
